<div class="container contract-summary app-page-titles--summary">
  <div class="container-body">
    @if (blockedUi) {
    <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
      <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
    </div>
    }

    <div class="grid">
      <div class="col-12 client-data-apply_margin_bottom">
        <span class="client-data-title">
          {{ 'TRANSLATE.PLAN.SUMMARY' | translate }}
        </span>
      </div>
    </div>

    <div class="summary-content-shell">
      <div class="summary-content">
        <div class="p-fluid fluid">
          <form [formGroup]="userform">
            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="summary-section-title">{{ 'TRANSLATE.VEHICLE.DATA' | translate }}</div>
                <div class="vehicle-grid">
                  <!-- Column 1: Left Data -->
                  <div class="vehicle-col">
                    <div class="vehicle-info-pair vehicle-info-pair--left">
                      <span class="vehicle-info-key">{{ 'TRANSLATE.TWO.POINTS.CHASSI.NUMBER' | translate }}</span>
                      <span class="vehicle-info-val">{{ vinValidate.vin }}</span>
                    </div>
                    <div class="vehicle-info-pair vehicle-info-pair--left">
                      <span class="vehicle-info-key">{{ 'TRANSLATE.TWO.POINTS.MODEL' | translate }}</span>
                      <span class="vehicle-info-val">{{ vinValidate.modelName }}</span>
                    </div>
                    <div class="vehicle-info-pair vehicle-info-pair--left">
                      <span class="vehicle-info-key">{{ 'TRANSLATE.TWO.POINTS.ODOMETER' | translate }}</span>
                      <span class="vehicle-info-val">{{ maskOdometer(vinValidate.odometro) }}</span>
                    </div>
                  </div>

                  <!-- Column 2: Right Data -->
                  <div class="vehicle-col">
                    <div class="vehicle-info-pair vehicle-info-pair--right">
                      <span class="vehicle-info-key">{{ 'TRANSLATE.TWO.POINTS.MODEL.YEAR' | translate }}</span>
                      <span class="vehicle-info-val">{{ vinValidate.modelYear }}</span>
                    </div>
                    <div class="vehicle-info-pair vehicle-info-pair--right">
                      <span class="vehicle-info-key">{{ 'TRANSLATE.TWO.POINTS.WARRANTY' | translate }}</span>
                      <span class="vehicle-info-val">{{ vinValidate.warrantyStartDate | date:
                        'dd/MM/yyyy':'UTC'}}</span>
                    </div>
                  </div>

                  <!-- Column 3: Image -->
                  <div class="vehicle-image-col">
                    <img class="vehicle-summary-image" src="../../../assets/image/vin/car.png" alt="">
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="summary-section-title">{{ 'TRANSLATE.CONTRACT.SUMMARY' | translate }}</div>
                <div class="contract-container">
                  <!-- INCLUDED Section -->
                  <div class="contract-section">
                    <div class="contract-header">
                      <span class="summary-inline-heading">{{ 'TRANSLATE.INCLUDED' | translate }}</span>
                    </div>
                    <div class="contract-items">
                      <div class="contract-item">
                        <span>{{ choosePlanBuyng.factoryTimeLimit }} {{ 'TRANSLATE.MONTHS.WARRANTY' | translate }}
                        </span>
                        @if (choosePlanBuyng.factoryDistanceLimit === 999999) {
                        <span class="vehicle-info-val">{{ 'TRANSLATE.PARENTHESES.UNLIMITED.KM' | translate }}</span>
                        }
                        @if (choosePlanBuyng.factoryDistanceLimit !== 999999) {
                        <span class="vehicle-info-val">{{ choosePlanBuyng.factoryDistanceLimit }} {{
                          'TRANSLATE.WARRANTY.KM' | translate }}</span>
                        }
                      </div>
                      <div class="contract-item">
                        <span>{{ 'TRANSLATE.FORD.ASSISTANCE.YEAR.HOUR' | translate }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- CONTRACTED Section -->
                  <div class="contract-section">
                    <div class="contract-header">
                      <span class="summary-inline-heading">{{ 'TRANSLATE.CONTRACTED' | translate }}</span>
                    </div>
                    <div class="contract-grid">
                      <!-- Extension Row -->
                      @if (choosePlanBuyng.extension?.itemPrice > 0) {
                      <div class="contract-item-row">
                        <span class="item-name">{{ choosePlanBuyng.extension?.planName }}</span>
                        <span class="item-time">{{ choosePlanBuyng.extension?.limitTime }} {{ 'TRANSLATE.MONTHS' |
                          translate }}</span>
                        <span class="item-distance">{{ choosePlanBuyng.extension?.limitDistance }} {{ 'TRANSLATE.KM' |
                          translate }}</span>
                        <span class="item-price">{{ choosePlanBuyng.extension?.itemPrice | currency :
                          getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}</span>
                      </div>
                      }

                      <!-- Maintenance Row -->
                      @if (choosePlanBuyng.maintenance?.itemPrice > 0) {
                      <div class="contract-item-row">
                        <span class="item-name">{{ choosePlanBuyng.maintenance?.planName }}</span>
                        <span class="item-time">{{ choosePlanBuyng.maintenance?.limitTime }} {{ 'TRANSLATE.MONTHS'
                          | translate }}</span>
                        <span class="item-distance">{{ choosePlanBuyng.maintenance?.limitDistance }} {{ 'TRANSLATE.KM'
                          | translate }}</span>
                        <span class="item-price">{{ choosePlanBuyng.maintenance?.itemPrice | currency :
                          getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}</span>
                      </div>
                      }

                      <!-- Part Row -->
                      @if (choosePlanBuyng.part?.itemPrice > 0) {
                      <div class="contract-item-row">
                        <span class="item-name">{{ choosePlanBuyng.part?.planName }}</span>
                        <span class="item-time">{{ choosePlanBuyng.part?.limitTime }} {{ 'TRANSLATE.MONTHS' |
                          translate }}</span>
                        <span class="item-distance">{{ choosePlanBuyng.part?.limitDistance }} {{ 'TRANSLATE.KM' |
                          translate }}</span>
                        <span class="item-price">{{ choosePlanBuyng.part?.itemPrice | currency :
                          getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}</span>
                      </div>
                      }

                      <!-- TOTAL (Integrated in grid) -->
                      <div class="contract-total">
                        <span class="total-label">{{ 'TRANSLATE.TWO.POINTS.TOTAL' | translate }}</span>
                        <span class="total-value">{{ choosePlanBuyng?.totalPrice | currency :
                          getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="summary-section-title">{{ 'TRANSLATE.CLIENT.DATA' | translate }}</div>
                <div class="client-grid">
                  <div class="client-field client-field--full">
                    <span class="client-info-key">{{ 'TRANSLATE.TWO.POINTS.NAME.RS.CONTRACT' | translate }}</span>
                    <span class="client-info-val">{{ clientData.firstname }} {{ clientData.lastname }}</span>
                  </div>

                  @if (clientData.customerSocialName && clientData.customerSocialName.trim()) {
                  <div class="client-field client-field--full">
                    <span class="client-info-key">{{'TRANSLATE.SOCIAL.NAME.TWO.POINTS' | translate }}</span>
                    <span class="client-info-val">{{ clientData.customerSocialName }}</span>
                  </div>
                  }

                  <div class="client-field client-field--col-3">
                    <span class="client-info-key">{{ getDocumentLabel(clientData.nationalId) }}</span>
                    <span class="client-info-val">{{ getSummaryDocumentValue(clientData.nationalId) }}</span>
                  </div>

                  @if (systemCountry === 'BRA') {
                  <div class="client-field client-field--col-3">
                    <span class="client-info-key">{{ 'TRANSLATE.TWO.POINTS.BIRTH.DATE' | translate }}</span>
                    <span class="client-info-val">{{ clientData.birthDate | date:'dd/MM/yyyy' }}</span>
                  </div>
                  }

                  <div class="client-field client-field--col-3">
                    <span class="client-info-key">{{ 'TRANSLATE.TWO.POINTS.PHONE' | translate }}</span>
                    <span class="client-info-val">{{ maskPhoneNumber(clientData.phone1) }}</span>
                  </div>

                  <div class="client-field client-field--col-2">
                    <span class="client-info-key">{{ 'TRANSLATE.TWO.POINTS.ADDRESS' | translate }}</span>
                    <span class="client-info-val">{{ clientData.address }}, {{ clientData.number }}</span>
                  </div>

                  <div class="client-field client-field--col-2">
                    <span class="client-info-key">{{ 'TRANSLATE.TWO.POINTS.CITY' | translate }}</span>
                    <span class="client-info-val">{{ clientData.city }} - {{ clientData.stateCode }}</span>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="section-box-title">{{ 'TRANSLATE.DEALER.DATA' | translate }}</div>
                <div class="dealer-grid">
                  <div class="dealer-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.CODE' | translate }}</span>
                    <p-inputMask (change)="getDealer($event); onFormChange()" formControlName="dealerCodigo"
                      mask="99999" inputId="dealerCodigo"
                      placeholder="{{ 'TRANSLATE.CODE' | translate }}"></p-inputMask>
                    @if (submitted && userform.controls['dealerCodigo'].pending) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.DEALER.DATA.CORRECTLY' | translate }}"></p-message>
                    }
                  </div>
                  <div class="dealer-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.NAME' | translate }}</span>
                    @if (contractSummary.dealer?.legalName) {
                    <span class="summary-value dealer-name-value">{{ contractSummary.dealer.legalName }}</span>
                    }
                  </div>
                </div>

                <div class="dealer-field-full">
                  <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate }}</span>
                  <input id="dealerEmail" formControlName="dealerEmail" type="text"
                    placeholder="{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate }}" pInputText>
                  @if (submitted && isDealerCodeValid && userform.controls['dealerEmail'].pending) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFO.EMAIL.CORRECT.DEALER' | translate }}"></p-message>
                  }
                </div>
              </div>
            </fieldset>

            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="section-box-title">{{ 'TRANSLATE.SALESMAN.DATA' | translate }}</div>

                <div class="seller-grid">
                  <div class="seller-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.USER' | translate }}</span>
                    <input (change)="getDealerSeller($event); onFormChange()" formControlName="cdsidSeller" pInputText
                      minlength="1" maxlength="15" type="text" placeholder="t-campos8"
                      onblur="this.value=this.value.toUpperCase()">
                    @if (submitted && userform.controls['cdsidSeller'].pending) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.INFORM.USER.SALESMAN' | translate }}"></p-message>
                    }
                  </div>
                  <div class="seller-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.NAME' | translate }}</span>
                    <input formControlName="nameSeller" type="text" minlength="1" maxlength="100"
                      placeholder="{{ 'TRANSLATE.NAME' | translate }}" pInputText (change)="onFormChange()">
                    @if (submitted && userform.controls['nameSeller'].pending) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.INFORM.NAME.SALESMAN' | translate }}"></p-message>
                    }
                  </div>
                  <div class="seller-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.PHONE' | translate }}</span>
                    <input id="phoneSeller" formControlName="inputPhoneSeller" type="text"
                      placeholder="{{ 'TRANSLATE.PHONE' | translate }}" [minlength]="phoneMinLength"
                      [maxlength]="phoneMaxLength" (keydown)="allowOnlyDigits($event)"
                      (paste)="handlePhonePaste($event)" (input)="enforceNumericPhoneInput($event)" inputmode="numeric"
                      pInputText (change)="onFormChange()">
                    @if (submitted && (userform.controls['inputPhoneSeller'].pending ||
                    (userform.controls['inputPhoneSeller'].invalid &&
                    (userform.controls['inputPhoneSeller'].dirty || userform.controls['inputPhoneSeller'].touched))))
                    {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.INFORM.PHONE.SALESMAN' | translate }}"></p-message>
                    }
                  </div>
                  <div class="seller-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate }}</span>
                    <input formControlName="emailSeller" type="text" minlength="1" maxlength="50"
                      placeholder="{{ 'TRANSLATE.EMAIL' | translate }}" pInputText (change)="onFormChange()">
                    @if (submitted && userform.controls['emailSeller'].pending) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.INFO.EMAIL.CORRECT.SELLER' | translate }}"></p-message>
                    }
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="summary-section-block">
              <div class="summary-section-inner">
                <div class="summary-section-title">{{ 'TRANSLATE.DATA.PAYMENT' | translate }}</div>
                <div class="payment-container">
                  <div class="payment-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.PAYMENT.VEHICLE' | translate }}</span>
                    <p-dropdown formControlName="typePayment" [options]="dropdownTypePayment"
                      placeholder="{{ 'TRANSLATE.SELECT' | translate }}" optionLabel="label"
                      (onChange)="paymentTypeOnChange($event)" (change)="onFormChange()">
                      <ng-template pTemplate="item" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                      <ng-template pTemplate="selectedItem" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                    </p-dropdown>
                    @if (submitted && (userform.controls['typePayment'].pending || userform.controls['typePayment'].value === null || userform.controls['typePayment'].value === undefined || userform.controls['typePayment'].value === '')) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.SELECT.PAYMENT.VEHICLE' | translate }}"></p-message>
                    }
                  </div>

                  <div class="payment-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.FORM.OF.PAYMENT' | translate }}</span>
                    <p-dropdown formControlName="formaPayment" [options]="dropdownFormaPayment"
                      placeholder="{{ 'TRANSLATE.SELECT' | translate }}" optionLabel="label" optionValue="value"
                      (onChange)="updateForma()" (change)="onFormChange()">
                      <ng-template pTemplate="item" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                      <ng-template pTemplate="selectedItem" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                    </p-dropdown>

                    @if (submitted && (userform.controls['formaPayment'].pending || userform.controls['formaPayment'].value === null || userform.controls['formaPayment'].value === undefined || userform.controls['formaPayment'].value === '')) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.SELECT.FORM.OF.PAYMENT' | translate }}"></p-message>
                    }
                  </div>

                  <div class="payment-field">
                    <span class="summary-form-label">{{ 'TRANSLATE.TWO.POINTS.PAYMENT.TERM' | translate }} </span>
                    <p-dropdown formControlName="prazoPayment" [options]="dropdownPrazoPayment"
                      placeholder="{{ 'TRANSLATE.SELECT' | translate }}" optionLabel="label" optionValue="value"
                      (change)="onFormChange()">
                      <ng-template pTemplate="item" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                      <ng-template pTemplate="selectedItem" let-item>
                        {{item?.label | translate}}
                      </ng-template>
                    </p-dropdown>

                    @if (submitted && (userform.controls['prazoPayment'].pending || userform.controls['prazoPayment'].value === null || userform.controls['prazoPayment'].value === undefined || userform.controls['prazoPayment'].value === '')) {
                    <p-message class="client-data-message" severity="error"
                      text="{{'TRANSLATE.SELECT.PAYMENT.TERM' | translate }}"></p-message>
                    }
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-8 button-position">

      <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonComeBack()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>

      <app-cta-button id="btnAdvance"
        [label]="systemCountry === 'CHL' || systemCountry === 'COL' ? 'TRANSLATE.FINALIZE' : 'TRANSLATE.ADVANCE'"
        [successState]="isCtaSuccess" [disabled]="blockedUi" (buttonClick)="buttonNext()">
      </app-cta-button>

    </div>
  </div>
</div>